interface AddressComponent {
  long_name: string;
  short_name: string;
  types: string[];
}

export interface Place {
  address_components: AddressComponent[];
}

export const getAddressComponentFromPlace = (
  place: Place,
  type: string | string[]
): string | undefined =>
  place.address_components.find(component =>
    Array.isArray(type)
      ? type.some(t => component.types.includes(t))
      : component.types.includes(type)
  )?.long_name;

// Google splits the street line into separate `street_number` and `route`
// components; combine them into the single line our ShippingData.streetAddress
// expects. Returns '' (never undefined) when neither component is present, so
// callers can safely no-op on a falsy result instead of writing "undefined".
export const buildStreetAddressLine = (place: Place): string =>
  [
    getAddressComponentFromPlace(place, 'street_number'),
    getAddressComponentFromPlace(place, 'route'),
  ]
    .filter(Boolean)
    .join(' ');
